import { isEmpty } from 'lodash';
import React, { useState, useEffect, memo } from 'react';
import styled from 'styled-components';

import Button from '../../../Button';
import TicketCardWithManager from '../TicketCardWithManager';
import { RelativeTicketType } from 'types/types';

interface ITicketCardWithManagerList {
  className?: string;
  tickets: RelativeTicketType[];
  visible?: number;
  getOrderURLById: (orderId: string) => string;
  onSelect: (ticketId: string) => void;
}

const TicketCardWithManagerList = ({
  tickets,
  visible = 3,
  onSelect,
  getOrderURLById,
  ...props
}: ITicketCardWithManagerList) => {
  const [isExpand, setIsExpand] = useState(false);

  useEffect(() => {
    setIsExpand(false);
  }, [tickets]);

  if (isEmpty(tickets)) {
    return null;
  }

  const hasHidden = tickets.length > visible;
  const shownTickets = isExpand ? tickets : tickets.slice(0, visible);

  return (
    <StyledTicketsList {...props}>
      {shownTickets.map(shownTicket => {
        const { ticket, manager } = shownTicket;

        return (
          <div key={ticket.id}>
            <StyledTicketCard
              manager={manager}
              getOrderURLById={getOrderURLById}
              ticket={ticket}
              onSelect={onSelect}
            />
            <StyledSeparator />
          </div>
        );
      })}
      {!isExpand && hasHidden && (
        <StyledShowMoreButton functional onClick={setIsExpand}>
          Показать все тикеты
        </StyledShowMoreButton>
      )}
    </StyledTicketsList>
  );
};

const StyledTicketsList = styled.div`
  display: flex;
  padding: 0 5px;
  flex-direction: column;
`;

const StyledTicketCard = styled(TicketCardWithManager)`
  height: auto;
  box-sizing: border-box;
  border-radius: 2px;
`;

const StyledSeparator = styled.div`
  height: 10px;
`;

const StyledShowMoreButton = styled(Button)`
  margin-top: auto;
  color: #007aff;
  font-size: 12px;
  padding: 0 5px;
  text-align: left;
  z-index: 10;
`;

export default memo(TicketCardWithManagerList);
